<template>
  <div class="ERcode">
    <el-row :gutter="20">
      <el-radio-group v-model="radio" @change="selectUrl()">
        <el-col :span="12" v-for="(item, index) in url" :key="index">
          <el-radio :label="item.val">{{ item.name }}</el-radio>
        </el-col>
      </el-radio-group>
    </el-row>
    <el-form ref="form" :model="form" label-width="120px">
      <el-form-item label="渠道号：">
        <el-input v-model="form.channel"></el-input>
      </el-form-item>
      <el-form-item label="邀请码(选填)：">
        <el-input v-model="form.shareUid"></el-input>
      </el-form-item>
      <el-form-item label="基金代码：">
        <el-input
          v-model="form.code"
          :disabled="radio == '3' || radio == '6' ? false : true"
        ></el-input>
      </el-form-item>
      <el-form-item label="活动链接：">
        <el-input
          type="textarea"
          :disabled="radio == '9' ? false : true"
          placeholder="活动页跳转链接请联系开发索取"
          v-model="form.url"
        ></el-input>
      </el-form-item>
    </el-form>
    <p style="font-size: 16px">活动页跳转链接请联系开发索取</p>
    <div class="btn">
      <el-button
        type="primary"
        round
        @click="submitURL()"
        style="margin-right: 30px"
        >生成小程序二维码</el-button
      >
      <el-button type="primary" round @click="submitQRCodeURL()"
        >生成H5二维码</el-button
      >
      <el-button type="primary" round @click="createMsgLink()"
        >生成短信链接</el-button
      >
    </div>

    <div style="font-size: 18px; width: 500px">
      地址：<br />
      <el-input
        type="textarea"
        disabled
        :rows="15"
        placeholder="请输入内容"
        v-model="H5FullUrl"
      >
      </el-input>
      <el-dialog
        title="扫码进入H5页面"
        :visible="dialogVisible"
        width="30%"
        :before-close="handleClose"
      >
      <div v-if="qrCodeFlag == 'H5'">
        <span class="title-msg">{{ titleMsg }}</span>
        <div ref="qrImg" class="qr-img">
          <div id="qrcode" ref="qrcode"></div>
          <img :src="form.src" class="qr-logo"/>
        </div>
      </div>
      <div class="qr-img" v-if="qrCodeFlag == 'mini'">
        <img class="mini-wx-qrCode" :src="miniprogramQrCode">
        <p>{{H5FullUrl}}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose()">取 消</el-button>
        <el-button type="primary" @click="DownLoad()">下载二维码</el-button>
      </span>
      </el-dialog>
    </div>
    <a class="download-mini-qrCode"></a>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import html2canvas from 'html2canvas';
import createKey from './createKey'
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      qrCodeFlag: '',
      miniprogramQrCode: '',
      radio: "0",
      dialogVisible: false,
      form: {
        channel: "",
        shareUid: "",
        code: "",
        url: "",
        src:require('../../assets/img/logo@3x.png')
      },
      isFileDis: true,
      isActiveDis: true,
      // urlfull:"",
      url: [
        {
          name: "首页关注",
          val: "0",
        },
        {
          name: "首页发现",
          val: "1",
        },
        {
          name: "首页我的",
          val: "2",
        },
        {
          name: "基金详情页",
          val: "3",
        },
        {
          name: "全部基金页面",
          val: "4",
        },
        {
          name: "新发基金列表页",
          val: "5",
        },
        {
          name: "新发基金详情页",
          val: "6",
        },
        {
          name: "我的自选页",
          val: "7",
        },
        {
          name: "现金通充值",
          val: "8",
        },
        {
          name: "活动",
          val: "9",
        },
      ],
      shareUid: "", //邀请人ID
      channel: "",
      // 首页关注tab、公共url
      webviewUrl: 'pages/index/index',
      url1: "pages/attention/attention",
      // 首页发现tab
      url2: "pages/find/find",
      url3: "pages/userCenter/userCenter",
      //基金详情页
      targetUrl1:
        "https%3A%2F%2Fm.pyamc.com%2Ftrade%2F%23%2FFundDetail%3Fcode%3D",
      // 全部基金页
      targetUrl2: "https%3A%2F%2Fm.pyamc.com%2Ftrade%2F%23%2FFundList%3F",
      // 新发基金列表
      targetUrl3: "https%3A%2F%2Fm.pyamc.com%2Ftrade%2F%23%2FNewFund%3F",
      // 新发基金详情页
      targetUrl4:
        "https%3A%2F%2Fm.pyamc.com%2Ftrade%2F%23%2FNewFundsDetail%3Fcode%3D",
      // 自选页
      targetUrl5: "https%3A%2F%2Fm.pyamc.com%2Ftrade%2F%23%2FUserWatchList%3F",
      // 现金通充值
      targetUrl6: "https%3A%2F%2Fm.pyamc.com%2Ftrade%2F%23%2FCashRecharge%3F",
      fullUrl: "",
      H5FullUrl: "",
      titleMsg: ""
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.fullUrl = this.webviewUrl;
  },
  methods: {
    createMsgLink() {
      if(!!!this.form.url) {
        this.$message({
          message: "活动链接不能为空",
          type: "warning",
        });
        return
      }
      if(!!!this.form.channel) {
        this.$message({
          message: "渠道号不能为空",
          type: "warning",
        });
        return
      }
      const url = `https://cloud1-8gs7xwd38af8742a-1308921468.tcloudbaseapp.com/index.html?sign=bfe2ad8274db56431baec7add75199f1&t=1658199897&channel=${this.channel}&src=${encodeURIComponent(this.form.url)}&shareUid=${this.shareUid}`
      console.log('短信链接：', url)
      this.H5FullUrl = url
    },

    async createMiniprogramQrCode(path) {
      this.qrCodeFlag = 'mini'
      const page = path.split('?')[0]
      const id = createKey(path)
      console.log('createMiniprogramQrCode-----', id, path)
      this.saveShareLink(id, path.split('?')[1])
      const param = {
        auto_color: false,
        check_path: true,
        env_version: 'release',
        is_hyaline: false,
        page: page,
        scene: `share.${id}`,
        width: 1280
      }
      const {data} = await this.axios.post('https://market.pyamc.com/api/third/weChat/createQRCode', param)
      this.miniprogramQrCode = 'data:image/png;base64,' + data.data
      this.dialogVisible = true
    },

    downMiniprogramQrCode() {
      const dom = document.querySelector('.download-mini-qrCode')
      dom.href = this.miniprogramQrCode
      dom.download = `${new Date().getTime()}`
      dom.click()
    },

    async saveShareLink(id, query) {
      const param = {
        active: true,
        configItemKey: `share.${id}`,
        configItemValue: query
      }
      try {
        const {data, msg} = await this.axios.post('https://market.pyamc.com/api/third/updateConfigItem', param)
        if(!!!data.data) {
          console.log('saveShareLink---err', msg)
        }
      } catch (error) {
        console.log('saveShareLink---err', error.message)
      }
    },
    // 下载二维码
    DownLoad() {
      if(this.qrCodeFlag == 'mini') {
        this.$nextTick(() => {
          this.downMiniprogramQrCode();
        })
      } else {
        html2canvas(this.$refs.qrImg).then(function(canvas) {
          let dataUrl=canvas.toDataURL('image/png')
          console.log(dataUrl)
          var url = dataUrl;
          // 获取图片地址
          var a = document.createElement("a"); // 创建一个a节点插入的document
          var event = new MouseEvent("click"); // 模拟鼠标click点击事件
          a.download = "好基通"; // 设置a节点的download属性值
          a.href = url; // 将图片的src赋值给a节点的href
          a.dispatchEvent(event);
        })
      }

      //var imgP = document.getElementById("qrcode");
      // .getElementsByTagName('img');  // 获取要下载的图片
      //var img = imgP.getElementsByTagName("img")[0];
      // var url = img.src;
      // // 获取图片地址
      // var a = document.createElement("a"); // 创建一个a节点插入的document
      // var event = new MouseEvent("click"); // 模拟鼠标click点击事件
      // // a.download = "好基通"; // 设置a节点的download属性值
      // // a.href = url; // 将图片的src赋值给a节点的href
      // // a.dispatchEvent(event);
    },
    // 生成二维码
    qrcode(url) {
      let qrcode = null;
      qrcode = new QRCode("qrcode", {
        width: 200,
        height: 200,
        text: url,
      });
    },
    // 选在页面
    selectUrl() {
      this.url.map((item) => {
        if (item.val == this.radio) {
          this.titleMsg = item.name;
        }
      });
      if(this.radio == "0") {
        this.fullUrl = this.url1;
      } else if (this.radio == "1") {
        this.fullUrl = this.url2;
      } else if (this.radio == "2") {
        this.fullUrl = this.url3;
      } else {
        this.fullUrl = this.webviewUrl;
      }
      if (this.radio != "3" && this.radio != "6") {
        this.form.code = "";
      }
      if (this.radio != "9") {
        this.form.url = "";
      }
    },
    noshareUid() {},
    // H5生成二维码
    submitQRCodeURL() {
      if (
        this.radio == "0" ||
        this.radio == "2" ||
        this.radio == "7" ||
        this.radio == "8"
      ) {
        this.$message({
          message: "该页面为小程序专有页面，无法生成H5二维码",
          type: "warning",
        });
        this.dialogVisible = false;
        return;
      } else {
        if (this.form.channel == "") {
          this.$message({
            message: "渠道码不能为空",
            type: "warning",
          });
          this.H5FullUrl = "";
          this.dialogVisible = false;
          return;
        } else {
          this.dialogVisible = true;
          if (this.radio == "1") {
            this.H5FullUrl = "https://m.pyamc.com/trade/#/Recommend";
          } else if (this.radio == "3" || this.radio == "6") {
            if (this.form.code == "") {
              this.$message({
                message: "基金代码不能为空",
                type: "warning",
              });
              this.H5FullUrl = "";
              this.dialogVisible = false;
              return;
            } else {
              if (this.radio == "3") {
                this.H5FullUrl =
                  decodeURIComponent(this.targetUrl1) +
                  this.form.code +
                  "&channel=" +
                  this.form.channel;
              }
              if (this.radio == "6") {
                this.H5FullUrl =
                  decodeURIComponent(this.targetUrl4) +
                  this.form.code +
                  "&channel=" +
                  this.form.channel;
              }
              this.dialogVisible = true;
            }
          } else if (this.radio == "4") {
            this.H5FullUrl =
              decodeURIComponent(this.targetUrl2) +
              "&channel=" +
              this.form.channel;
          } else if (this.radio == "5") {
            this.H5FullUrl =
              decodeURIComponent(this.targetUrl3) +
              "&channel=" +
              this.form.channel;
          } else if (this.radio == "9") {
            if (this.form.url != "") {
              this.H5FullUrl = this.form.url + "?channel=" + this.form.channel;
            } else {
              this.$message({
                message: "活动链接不能为空",
                type: "warning",
              });
              this.dialogVisible = false;
            }
          }
          if (this.form.shareUid != "") {
            this.H5FullUrl = this.H5FullUrl + "&shareUid=" + this.form.shareUid;
          }
          console.log(this.H5FullUrl);
          this.qrCodeFlag = 'H5'
          this.$nextTick(() => {
            this.qrcode(this.H5FullUrl);
          });
        }
      }
    },
    // 关闭二维码弹窗
    handleClose() {
      this.H5FullUrl = "";
      this.dialogVisible = false;
      document.getElementById("qrcode").innerHTML = "";
    },
    // 生成小程序链接
    submitURL() {
      if(this.radio == '0') {
        this.fullUrl = this.url1;
      }
      let urlErq = "";
      if (this.form.channel == "") {
        this.$message({
          message: "渠道码不能为空",
          type: "warning",
        });
        this.H5FullUrl = "";
        return;
      } else {
        if (this.form.shareUid != "") {
          this.H5FullUrl =
            this.fullUrl +
            "?channel=" +
            this.form.channel +
            "&shareUid=" +
            this.form.shareUid;
          urlErq =
            this.fullUrl +
            "?channel=" +
            this.form.channel +
            "&shareUid=" +
            this.form.shareUid;
        } else {
          this.H5FullUrl = this.fullUrl + "?channel=" + this.form.channel;
          urlErq = this.H5FullUrl
        }
        if (this.radio == "3" || this.radio == "6") {
          // 判断基金代码
          if (this.form.code == "") {
            this.$message({
              message: "基金代码不能为空",
              type: "warning",
            });
            this.H5FullUrl = "";
            return;
          } else {
            if (this.radio == "3") {
              this.H5FullUrl =
                urlErq + "&targetUrl=" + this.targetUrl1 + this.form.code;
            }
            if (this.radio == "6") {
              this.H5FullUrl =
                urlErq + "&targetUrl=" + this.targetUrl4 + this.form.code;
            }
          }
        } else if (this.radio == "4") {
          this.H5FullUrl = urlErq + "&targetUrl=" + this.targetUrl2;
        } else if (this.radio == "5") {
          this.H5FullUrl = urlErq + "&targetUrl=" + this.targetUrl3;
        } else if (this.radio == "7") {
          this.H5FullUrl = urlErq + "&targetUrl=" + this.targetUrl5;
        } else if (this.radio == "8") {
          this.H5FullUrl = urlErq + "&targetUrl=" + this.targetUrl6;
        } else if (this.radio == "9") {
          if (this.form.url == "") {
            this.$message({
              message: "活动链接  不能为空",
              type: "warning",
            });
            this.H5FullUrl = "";
            return;
          } else {
            this.H5FullUrl = urlErq + "&targetUrl=" + encodeURIComponent(this.form.url);
          }
        }
      }
      this.createMiniprogramQrCode(this.H5FullUrl)
    },
  },
};
</script>

<style scoped lang="scss">
</style>

<style lang="scss">
  *{
    user-select: auto;
  }
.ERcode {
  .qr-img{
    padding:20px 0;
    width: 300px;
    margin:0 auto;
    position: relative;
    .qr-logo{
      position: absolute;
      left:50%;
      bottom:89px;
      width:50px;
      height: 50px;
      margin-left: -31px;
      // margin: 0 0 -25px;
      padding: 4px;
      background: #fff;
      border-radius: 3px;
    }

    .mini-wx-qrCode {
      width: 150px;
      height: 150px;
    }
  }
  .btn {
    margin: 10px 0;
    display: flex;
    justify-content: center;
  }
  .el-textarea.is-disabled .el-textarea__inner {
    color: #222;
  }
  .el-radio__label {
    font-size: 16px;
  }
  .el-col {
    padding: 10px 0;
  }
  .title-msg {
    text-align: center;
    line-height: 25px;
    display: block;
    font-size: 20px;
    margin-bottom: 10px;
  }
  #qrcode {
    img {
      margin: 0 auto;
    }
  }
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>



// WEBPACK FOOTER //
// src/views/tools/weappQRCode.vue